import { ElMessage } from 'element-plus'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { ConversationStatus } from '@protos/conversation_enums_pb'

import RouteNames from '@pc/router/route-names'
import { useChatWidgetsStore } from '@pc/store/chat-widgets'
import { useQuickFormsStore } from '@pc/store/quick-forms'

export const useQuickFormOpening = () => {
  const router = useRouter()
  const { t } = useI18n()

  const chatWidgetStore = useChatWidgetsStore()
  const quickFormsStore = useQuickFormsStore()

  const isKioskModeEnabled = computed(() => chatWidgetStore.isKioskModeEnabled)

  const openQuickFormPage = (params: {
    formUuid?: string
    messageId: number
    autoOpen?: boolean
  }) => {
    const query = router.currentRoute.value.query

    const { formUuid, messageId, autoOpen } = params

    query.formUuid = formUuid || ''

    if (autoOpen) {
      query.autoOpen = autoOpen.toString()
    }

    query.messageId = messageId.toString()

    router.push({
      name: RouteNames.quickFormPage,
      query: query,
    })
  }

  const canSubmitForm = (params: { messageId: number }) => {
    const { messageId } = params

    const isSubmitted = quickFormsStore.isSubmittedMessageForm(messageId)

    return !isSubmitted
  }

  const onQuickFormOpenHandler = (params: {
    status?: ConversationStatus
    formUuid?: string
    messageId: number
    autoOpen?: boolean
  }) => {
    const { status, messageId, formUuid, autoOpen } = params
    if (status === ConversationStatus.CLOSE && isKioskModeEnabled.value) {
      ElMessage.error(t('pt.labels.cannotOpenTheForm'))
      return
    }

    const canSubmit = canSubmitForm({ messageId })

    if (!canSubmit) {
      ElMessage.info(t('pt.labels.cannotSubmitForm'))
    } else {
      openQuickFormPage({
        formUuid,
        messageId,
        autoOpen,
      })
    }
  }

  return {
    openQuickFormPage,
    canSubmitForm,
    onQuickFormOpenHandler,
  }
}
